<script>
  import devices from './stores/DeviceStore.js';
  export let visible = true;
  export let device;
  export let showDeleteButton = true;

  let pendingDeletion;
  let acceptDeletion;

  let formFields = {};
  let error;
  let isLoadingUpdate;
  const patchDevice = async () => {
    isLoadingUpdate = true;
    device = {...device, ...formFields};
    const res = await devices.patch(device);
    if(!res.ok) error = res.body.message;
    if(res) isLoadingUpdate = false;
  }
  const deleteDevice = async () => {
    const res = await devices.delete(device);
    if(!res.ok) error = res.body.message;
  }

  const updateTags = value => {
    let tags = value.split(",");
    tags = tags.map(tag => tag.trim());
    formFields.tags = tags;
  }

  const qrHandler = () => {
    window.open(`https://tellsens.io/qr/?url=https://tellsens.io?deviceId=${device._id}&deviceEui=${device.deviceEui}`);
  }

</script>

{#if visible}
  <form class="mb-4" on:submit|preventDefault={patchDevice}>
    <div class="tag is-light mb-2">{device.type}</div>
    <div class="tag is-info mb-2 clickable" on:click={qrHandler} on:keydown={() => {}}>QR</div>
    <div class="field is-grouped is-grouped-multiline">
      <div class="control is-expanded">
        <div class="block mb-1 ml-2 is-size-7">
          Device Name
        </div>
        <input class="input is-small" size=16 type="text" placeholder="Device Title" value={device.title} on:input={e => formFields.title = e.target.value} required>
      </div>
      <div class="control is-expanded mr-0 has-icons-right">
        <div class="block mb-1 ml-2 is-size-7">
          EUI
        </div>
        <input class="input is-small" size=16 type="text" placeholder="Device EUI"  value={device.deviceEui} on:input={e => formFields.deviceEui = e.target.value} readonly>
        <span class="icon is-small is-right">
          <i class="fas fa-lock mb-2"></i>
        </span>
      </div>
      <div class="control is-expanded">
        <textarea class="textarea is-small" rows="2" cols="40" placeholder="Comma separated tags" value={device.tags.join(", ")} on:input={e => updateTags(e.target.value)}></textarea>
      </div>
        <div class="control">
          <button class="button is-small is-light" class:is-loading={isLoadingUpdate} type="submit" name="submit">Update</button>
        </div>
        {#if showDeleteButton}
        <div class="control">
          <button class="button is-small" type="button" on:click={() => pendingDeletion = true}>Delete</button>
        </div>
        {/if}
    </div>
    {#if pendingDeletion}
      <div class="mb-3">
        <label class="checkbox">
          <input type="checkbox" bind:checked={acceptDeletion} on:click={() => acceptDeletion = !acceptDeletion}>
          I want to delete the device <strong>{device.title}</strong> with the EUI <strong>{device.deviceEui}</strong>.
        </label>
      </div>
      <div class="mb-5">
        <span class="tag is-danger" on:keydown={() => {}} on:click={() => {if(acceptDeletion == true) deleteDevice()}} >Delete</span>
        <span class="tag is-light" on:keydown={() => {}} on:click={() => {pendingDeletion = false; acceptDeletion = false}}>Cancel</span>
      </div>
    {/if}
  </form>
{/if}

{#if error}
<div class="columns">
  <div class="column">
    <div class="field">
      <!-- svelte-ignore a11y-label-has-associated-control -->
      <label class="label">Error</label>
      <div class="control">
        <textarea class="textarea is-danger" placeholder="Error" value={error}></textarea>
      </div>
    </div>
  </div>
</div>
{/if}

<style>
  button {
  width: 70px;
}
  .clickable:hover {
    cursor: pointer;
  }

.tag {
  cursor: pointer;
}
</style>
